import { Attachment } from '@/GeneratedTypes/Communication/Attachment'

export function getEmptyAttachment(): Attachment {
  return {
    data: '',
    name: '',
    type: '',
  }
}
